import React, { useState } from 'react';
import { MdControlPoint, MdDelete } from 'react-icons/md';
import { Link } from 'react-router-dom';
import MessageBox from './MessageBox';
import { RxReload } from 'react-icons/rx';
import AdminTooltip from './AdminTooltip';
import Modal from 'react-bootstrap/Modal'; // Assuming you're using react-bootstrap

const AdminNavbar = ({
    heading,
    totalDataLength,
    deleteCount,
    deleteMethod,
    navigation,
    navText,
    addIconHide,
    reloadAction,
    reload,
    reLoading,
    classname,
    footerColumn,
    navState
}) => {
    const [showModal, setShowModal] = useState(false);

    const handleModalOpen = () => setShowModal(true);
    const handleModalClose = () => setShowModal(false);

    return (
        <>
            <div className="d-flex align-items-center flex-wrap pb-3">
                <div className={`${classname ? classname : "col-md-6"} col-12`}>
                    <h4 className="admin-title mb-0 theme-text-color text-md-start">
                        <MessageBox text={heading} classname="theme-text-color" />
                        <span className="admin-sub-title theme-text-color ms-2">
                            ( {totalDataLength}{' '}
                            <MessageBox text="results found" classname="theme-text-color" /> )
                        </span>
                    </h4>
                </div>

                <div className="col-md-6 col-12 d-flex align-items-center justify-content-end mt-3 mt-sm-0">
                    {deleteCount > 0 && (
                        <button
                            className="px-4 py-2 rounded-2 warningColorBg d-inline-flex align-items-center"
                            id="deleteActionButton"
                            onClick={deleteMethod}
                        >
                            <MdDelete className="exportIcon me-1" fill="#fff" />
                            <MessageBox text="Delete" classname="admin-button-text" />
                        </button>
                    )}

                    {navigation && (
                        <Link
                            to={`${navigation}`}
                            state={navState}
                            className="admin-title ms-3 rounded-2 d-inline-flex align-items-center button-bg-color theme-button-text-color text-decoration-hover py-2 px-3"
                            id="navigationLinkForAddPage"
                        >
                            {!addIconHide && (
                                <MdControlPoint
                                    className="me-2 exportIcon"
                                    style={{ width: '22px', height: '22px' }}
                                />
                            )}
                            <MessageBox classname="admin-button-text" text={navText} />
                        </Link>
                    )}

                    {reload && (
                        <button
                            className="bg-transparent custom-tool-tip-parent reloadButton theme-text-color p-2 me-2 border border-2 rounded-circle theme-border-color"
                            onClick={reloadAction}
                            id="reloadButton"
                        >
                            <RxReload
                                style={{ width: '18px', height: '15px', color: 'currentcolor' }}
                                className={`${reLoading ? 'rotate-load' : ''}`}
                            />
                            <AdminTooltip text="Refresh" top="-30px" className="d-none custom-tool-tip" />
                        </button>
                    )}

                    {/* New Update Column button for footerColumn */}
                    {footerColumn && (
                        <button
                            className="btn btn-outline-primary ms-3 px-2 py-2"
                            onClick={handleModalOpen}
                            id="updateColumnButton"
                        >
                            Update Column
                        </button>
                    )}
                </div>
            </div>

            {/* Modal for Update Column */}
            <Modal show={showModal} onHide={handleModalClose} centered>
                <Modal.Header closeButton>
                    <Modal.Title>Update Column</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <p>This is the popup triggered by the Update Column button.</p>
                </Modal.Body>
                <Modal.Footer>
                    <button className="btn btn-secondary" onClick={handleModalClose}>
                        Close
                    </button>
                </Modal.Footer>
            </Modal>
        </>
    );
};

export default AdminNavbar;
